import { Row, Col, Breadcrumb } from "react-bootstrap";
import { IComplaintDetails } from "../../../api/IComplaint";
import { ILicenceProfile } from "../../../api/ILicenceProfile";

interface BreadcrumbProps {
  licenceProfile: ILicenceProfile;
  complaintDetails: IComplaintDetails;
}

const BreadCrumbs = ({ licenceProfile, complaintDetails }: BreadcrumbProps) => (
  <Row>
    <Col xs="12">
      <Breadcrumb className="leap">
        <Breadcrumb.Item href="/">LEAP Online Home</Breadcrumb.Item>
        <Breadcrumb.Item href={`/licence-profile/${licenceProfile.profileNo}`}>
          {licenceProfile.organisation} - {licenceProfile.profileNo}
        </Breadcrumb.Item>
        <Breadcrumb.Item
          href={`/licence-profile/${licenceProfile.profileNo}/compliance`}
        >
          Compliance
        </Breadcrumb.Item>
        <Breadcrumb.Item active>{complaintDetails.reference}</Breadcrumb.Item>
      </Breadcrumb>
    </Col>
  </Row>
);

export default BreadCrumbs;
